import Entity from '../entity'
import SubjectComment from './SubjectComment';

export default class Subject extends Entity<number>{
    subjectNo: string = null;
    name: string = null;
    details: string = null;
    keywords: string = null;
    description: string = null;
    subjectCategoryId: number = null;
    coverImageUrl: string = null;
    priority: number = null;
    tenantId: number = null;
    isPublished: boolean;
    isRecommended: boolean;
    recommendedPriority: number = null;
    advertisementImageUrl: string = null;
    advertisementPriority: number = null;
    isAdvertisement: boolean;
    remark: string = null;
    subjectComments: Array<SubjectComment>;
}